// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__gDYM0","container":"Layout_container__sdw0F"};